let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("bi09N")).then(() => parcelRequire('7rjx9'));